// Where the embed script was served from, which is also where the widget API lives. Read at
// evaluation time: document.currentScript is only set while a classic script is executing.
const script = document.currentScript;

export const scriptOrigin = script?.src
  ? new URL(script.src).origin
  : window.location.origin;
